import { createContext, useContext, useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

const AlarmHistoryContext = createContext();

export const useAlarmHistory = () => {
  const context = useContext(AlarmHistoryContext);
  if (!context) {
    throw new Error('useAlarmHistory must be used within AlarmHistoryProvider');
  }
  return context;
};

export const AlarmHistoryProvider = ({ children }) => {
  const [alarmHistory, setAlarmHistory] = useState([]);

  const addAlarmToHistory = useCallback((alarmItem) => {
    setAlarmHistory((prev) => {
      const newHistory = [...prev, alarmItem];
      // Keep last 100 alarms to avoid memory issues
      return newHistory.slice(-100);
    });
  }, []);

  const clearHistory = useCallback(() => {
    setAlarmHistory([]);
  }, []);

  const removeFromHistory = useCallback((id) => {
    setAlarmHistory((prev) => prev.filter((item) => item.id !== id));
  }, []);

  const value = useMemo(
    () => ({
      alarmHistory,
      addAlarmToHistory,
      clearHistory,
      removeFromHistory,
    }),
    [alarmHistory, addAlarmToHistory, clearHistory, removeFromHistory]
  );

  return (
    <AlarmHistoryContext.Provider value={value}>
      {children}
    </AlarmHistoryContext.Provider>
  );
};

AlarmHistoryProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
